export const TabbedContentE2eDataHook = 'e2e-test-data-hook';
export { TabbedContentE2eDataHook as TABBED_CONTENT_E2E_DATA_HOOK };
export { TabbedContentDataHooks as TABBED_CONTENT_HOOKS } from './types';
